/**
 * 목록 메모 창 — 줄의 메모 아이콘 + 누르면 뜨는 작은 창(보고 · 고치고 · 저장). 제품 목록(2026-10-19)에서 나와 요청함 목록이 같이 쓴다.
 * 그리기 · 자리 재기만 여기. 상태(열린 창 하나)는 뷰의 this.data, 핸들러(열기 · 입력 · Esc · 저장)도 뷰마다 — 저장 API 가 목록마다 다르다.
 * data-action 넷: notes-toggle(아이콘, data-id = 줄 id) · notes-input(글상자) · notes-save · notes-close(닫기 · 바깥) · notes-pop(창 안 — 줄 열기로 안 넘어가게).
 */
import { escapeHtml } from '../lib/cells';

/** 열린 메모 창 — 한 번에 줄 하나. 자리는 아이콘의 화면 좌표(fixed — 표가 가로로 밀리는 .pv-body 에 안 잘리게) */
export type NotesPop = { rowId: string; draft: string; top: number; left: number; saving: boolean; error: string };

const NOTES_POP_WIDTH  = 320;
const NOTES_POP_HEIGHT = 200;   // 화면 밑에 붙은 줄이면 위로 연다
const NOTES_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h16v12l-4 4H4z"/><path d="M8 9h8M8 13h5"/></svg>';

/** 메모 아이콘 — 메모가 있으면 진하게, 올리면 글. 그 줄의 창이 열려 있으면 창도 함께 */
export function renderNotesButton(rowId: string, notesOrNull: string | null, popOrNull: NotesPop | null): string {
  const notes = notesOrNull === null ? '' : notesOrNull.trim();
  const title = notes === '' ? '메모 없음 — 눌러서 적기' : notes;
  return `
          <button type="button" class="pl-notes-btn${notes === '' ? '' : ' has-notes'}" data-action="notes-toggle" data-id="${escapeHtml(rowId)}" title="${escapeHtml(title)}" aria-label="메모">${NOTES_ICON}</button>
          ${popOrNull !== null && popOrNull.rowId === rowId ? renderNotesPop(popOrNull) : ''}`;
}

/** 새 창 — 아이콘 오른쪽 끝에 맞추고 화면 밖이면 안으로 */
export function notesPopAt(rowId: string, draft: string, button: HTMLElement): NotesPop {
  const rect = button.getBoundingClientRect();
  const left = Math.max(8, Math.min(rect.right - NOTES_POP_WIDTH, window.innerWidth - NOTES_POP_WIDTH - 8));
  const top = Math.max(8, Math.min(rect.bottom + 4, window.innerHeight - NOTES_POP_HEIGHT - 8));
  return { rowId, draft, top, left, saving: false, error: '' };
}

function renderNotesPop(pop: NotesPop): string {
  return `
      <div class="pl-notes-overlay" data-action="notes-close"></div>
      <div class="pl-notes-pop" data-action="notes-pop" role="dialog" aria-label="메모" style="top:${pop.top}px;left:${pop.left}px">
        <textarea class="pd-textarea" data-action="notes-input" rows="5" placeholder="메모 — 비우고 저장하면 지웁니다" ${pop.saving ? 'disabled' : ''}>${escapeHtml(pop.draft)}</textarea>
        ${pop.error === '' ? '' : `<p class="text-danger">${escapeHtml(pop.error)}</p>`}
        <div class="pl-notes-pop-buttons">
          <button type="button" class="btn-ghost" data-action="notes-close">닫기</button>
          <button type="button" class="btn-primary" data-action="notes-save" ${pop.saving ? 'disabled' : ''}>${pop.saving ? '저장 중…' : '저장'}</button>
        </div>
      </div>`;
}
